var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterestRejectActivityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "#FFEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0352 22.4463V46.7296C47.0352 48.6724 45.3373 50.248 43.2439 50.248H23.7561C21.6627 50.248 19.9648 48.6724 19.9648 46.7296V20.2704C19.9648 18.3276 21.6627 16.752 23.7561 16.752H40.6466V18.8314C40.6466 20.8278 42.3906 22.4463 44.5418 22.4463H47.0352Z",
    fill: "#F7F5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0307 22.4463H44.5417C42.3905 22.4463 40.6465 20.8278 40.6465 18.8314V16.752H40.6819L47.0307 22.4463Z",
    fill: "url(#paint0_linear_6779_1493)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0456 36.0293L39.0435 34.0314C39.2763 33.7985 39.461 33.5221 39.587 33.218C39.713 32.9138 39.7778 32.5877 39.7778 32.2585C39.7778 31.9292 39.713 31.6032 39.587 31.299C39.461 30.9948 39.2763 30.7184 39.0435 30.4856C38.5733 30.0154 37.9355 29.7512 37.2706 29.7512C36.6056 29.7512 35.9679 30.0154 35.4977 30.4856L33.4998 32.4835L31.5018 30.4856C31.0316 30.0154 30.3939 29.7512 29.7289 29.7512C29.064 29.7512 28.4262 30.0154 27.956 30.4856C27.7232 30.7184 27.5385 30.9948 27.4125 31.299C27.2865 31.6032 27.2217 31.9292 27.2217 32.2585C27.2217 32.5877 27.2865 32.9138 27.4125 33.218C27.5385 33.5222 27.7232 33.7986 27.956 34.0314L29.954 36.0293L27.956 38.0272C27.7232 38.26 27.5385 38.5364 27.4125 38.8406C27.2865 39.1448 27.2217 39.4708 27.2217 39.8001C27.2217 40.1294 27.2865 40.4554 27.4125 40.7596C27.5385 41.0638 27.7232 41.3402 27.956 41.573C28.1889 41.8058 28.4653 41.9905 28.7695 42.1165C29.0737 42.2425 29.3997 42.3074 29.7289 42.3074C30.0582 42.3074 30.3842 42.2425 30.6884 42.1165C30.9926 41.9905 31.269 41.8058 31.5019 41.573L33.4998 39.5751L35.4977 41.573C35.9679 42.0432 36.6056 42.3074 37.2706 42.3074C37.9355 42.3074 38.5732 42.0432 39.0434 41.573C39.2763 41.3402 39.461 41.0638 39.587 40.7596C39.713 40.4554 39.7778 40.1294 39.7778 39.8001C39.7778 39.4708 39.713 39.1448 39.587 38.8406C39.461 38.5364 39.2763 38.26 39.0434 38.0272L37.0456 36.0293Z",
    fill: "#E60000",
    fillOpacity: 0.81
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9143 50.2478H23.7561C21.6622 50.2478 19.9648 48.6721 19.9648 46.7293V20.2702C19.9648 18.3274 21.6622 16.7517 23.7561 16.7517H23.9714C23.2792 19.4964 22.9302 22.3163 22.9323 25.1469C22.9323 35.0693 27.1603 44.0045 33.9143 50.2478Z",
    fill: "#E4E3E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2433 50.6579H23.7561C21.4394 50.6579 19.5547 48.8956 19.5547 46.7293V23.5541C19.5547 23.4454 19.5979 23.341 19.6748 23.2641C19.7517 23.1872 19.8561 23.144 19.9648 23.144C20.0736 23.144 20.1779 23.1872 20.2549 23.2641C20.3318 23.341 20.375 23.4454 20.375 23.5541V46.7293C20.375 48.4433 21.8917 49.8376 23.7561 49.8376H43.2433C45.108 49.8376 46.625 48.4433 46.625 46.7293V22.8562H44.5414C42.1675 22.8562 40.2361 21.0506 40.2361 18.8312V17.1619H23.7561C21.8917 17.1619 20.375 18.5563 20.375 20.2702V20.3549C20.375 20.4637 20.3318 20.568 20.2549 20.645C20.1779 20.7219 20.0736 20.7651 19.9648 20.7651C19.8561 20.7651 19.7517 20.7219 19.6748 20.645C19.5979 20.568 19.5547 20.4637 19.5547 20.3549V20.2702C19.5547 18.1039 21.4394 16.3416 23.7561 16.3416H40.6463C40.7551 16.3416 40.8594 16.3848 40.9363 16.4617C41.0132 16.5386 41.0564 16.6429 41.0564 16.7517V18.8312C41.0564 20.5983 42.6198 22.0359 44.5414 22.0359H47.0352C47.1439 22.0359 47.2483 22.0791 47.3252 22.156C47.4021 22.2329 47.4453 22.3373 47.4453 22.446V46.7293C47.4453 48.8956 45.5603 50.6579 43.2433 50.6579Z",
    fill: "url(#paint1_linear_6779_1493)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9648 22.6724C19.8561 22.6724 19.7517 22.6292 19.6748 22.5522C19.5979 22.4753 19.5547 22.371 19.5547 22.2622V21.647C19.5547 21.5382 19.5979 21.4339 19.6748 21.3569C19.7517 21.28 19.8561 21.2368 19.9648 21.2368C20.0736 21.2368 20.1779 21.28 20.2549 21.3569C20.3318 21.4339 20.375 21.5382 20.375 21.647V22.2622C20.375 22.371 20.3318 22.4753 20.2549 22.5522C20.1779 22.6292 20.0736 22.6724 19.9648 22.6724Z",
    fill: "url(#paint2_linear_6779_1493)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0307 22.8564H44.5417C42.1677 22.8564 40.2363 21.0508 40.2363 18.8314V16.752C40.2363 16.6432 40.2795 16.5388 40.3565 16.4619C40.4334 16.385 40.5377 16.3418 40.6465 16.3418H40.6819C40.7829 16.3418 40.8805 16.3791 40.9557 16.4466L47.3046 22.1409C47.3664 22.1964 47.4099 22.2693 47.4294 22.35C47.4489 22.4306 47.4435 22.5154 47.4138 22.5929C47.3841 22.6704 47.3316 22.7371 47.2632 22.7842C47.1948 22.8313 47.1138 22.8564 47.0307 22.8564ZM41.0566 17.6391V18.8314C41.0566 20.5985 42.62 22.0361 44.5417 22.0361H45.9591L41.0566 17.6391Z",
    fill: "url(#paint3_linear_6779_1493)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2705 42.7176C36.8872 42.7186 36.5075 42.6436 36.1534 42.4969C35.7993 42.3503 35.4778 42.1348 35.2076 41.8631L33.4997 40.1552L31.7918 41.8631C31.2445 42.4098 30.5026 42.7167 29.7292 42.7165C28.9557 42.7163 28.2139 42.409 27.667 41.862C27.1201 41.3151 26.8127 40.5734 26.8125 39.7999C26.8123 39.0264 27.1193 38.2845 27.6659 37.7373L29.3738 36.0294L27.6659 34.3215C27.3944 34.0507 27.1789 33.7291 27.0318 33.375C26.8847 33.0208 26.8089 32.6412 26.8086 32.2577C26.8083 31.8743 26.8837 31.4945 27.0303 31.1402C27.1769 30.7859 27.3919 30.464 27.6631 30.1928C27.9342 29.9217 28.2562 29.7066 28.6105 29.56C28.9648 29.4134 29.3446 29.3381 29.728 29.3383C30.1115 29.3386 30.4911 29.4145 30.8452 29.5616C31.1994 29.7087 31.521 29.9242 31.7918 30.1957L33.4997 31.9036L35.2076 30.1957C35.4783 29.9241 35.8 29.7086 36.1541 29.5614C36.5082 29.4143 36.8879 29.3384 37.2714 29.3381C37.6548 29.3379 38.0346 29.4132 38.389 29.5598C38.7433 29.7064 39.0653 29.9215 39.3364 30.1926C39.6076 30.4638 39.8226 30.7858 39.9693 31.1401C40.1159 31.4944 40.1912 31.8742 40.1909 32.2577C40.1906 32.6412 40.1147 33.0208 39.9676 33.375C39.8204 33.7291 39.6049 34.0507 39.3334 34.3215L37.6255 36.0294L39.3334 37.7373C39.7414 38.1453 40.0192 38.6651 40.1318 39.231C40.2444 39.7969 40.1866 40.3835 39.9658 40.9166C39.745 41.4497 39.371 41.9053 38.8913 42.2259C38.4115 42.5465 37.8475 42.7176 37.2705 42.7176ZM33.4997 39.165C33.5535 39.165 33.6069 39.1755 33.6566 39.1961C33.7064 39.2168 33.7516 39.247 33.7897 39.2851L35.7876 41.2831C36.1809 41.6763 36.7143 41.8973 37.2705 41.8973C37.8266 41.8973 38.36 41.6763 38.7533 41.2831C39.1466 40.8898 39.3675 40.3564 39.3675 39.8002C39.3675 39.244 39.1466 38.7106 38.7533 38.3173L36.7554 36.3194C36.7173 36.2813 36.6871 36.2361 36.6665 36.1863C36.6459 36.1366 36.6353 36.0832 36.6353 36.0294C36.6353 35.9755 36.6459 35.9222 36.6665 35.8724C36.6871 35.8227 36.7173 35.7774 36.7554 35.7394L38.7533 33.7415C39.1456 33.348 39.3656 32.8149 39.3652 32.2593C39.3648 31.7037 39.1439 31.1709 38.751 30.7781C38.3581 30.3852 37.8254 30.1643 37.2698 30.1638C36.7142 30.1634 36.1811 30.3835 35.7876 30.7757L33.7897 32.7736C33.7127 32.8505 33.6084 32.8937 33.4996 32.8937C33.3909 32.8937 33.2866 32.8505 33.2096 32.7736L31.2117 30.7757C31.017 30.581 30.7858 30.4265 30.5314 30.3211C30.2769 30.2158 30.0043 30.1615 29.7289 30.1615C29.4535 30.1615 29.1808 30.2158 28.9263 30.3211C28.6719 30.4265 28.4407 30.581 28.246 30.7757C28.0513 30.9705 27.8968 31.2016 27.7914 31.4561C27.686 31.7105 27.6318 31.9832 27.6318 32.2586C27.6318 32.534 27.686 32.8067 27.7914 33.0611C27.8968 33.3155 28.0513 33.5467 28.246 33.7415L30.2439 35.7394C30.282 35.7774 30.3122 35.8227 30.3328 35.8724C30.3534 35.9222 30.364 35.9755 30.364 36.0294C30.364 36.0832 30.3534 36.1366 30.3328 36.1863C30.3122 36.2361 30.282 36.2813 30.2439 36.3194L28.246 38.3173C27.8527 38.7106 27.6318 39.244 27.6318 39.8002C27.6318 40.3564 27.8527 40.8898 28.246 41.283C28.6393 41.6763 29.1727 41.8973 29.7289 41.8973C30.285 41.8973 30.8184 41.6763 31.2117 41.283L33.2096 39.2851C33.2477 39.247 33.2929 39.2168 33.3427 39.1961C33.3924 39.1755 33.4458 39.165 33.4997 39.165Z",
    fill: "#FF7705"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7905 47.5657H22.3574C22.2486 47.5657 22.1443 47.5225 22.0674 47.4455C21.9905 47.3686 21.9473 47.2643 21.9473 47.1555C21.9473 47.0467 21.9905 46.9424 22.0674 46.8655C22.1443 46.7886 22.2486 46.7454 22.3574 46.7454H31.7905C31.8993 46.7454 32.0036 46.7886 32.0806 46.8655C32.1575 46.9424 32.2007 47.0467 32.2007 47.1555C32.2007 47.2643 32.1575 47.3686 32.0806 47.4455C32.0036 47.5225 31.8993 47.5657 31.7905 47.5657Z",
    fill: "url(#paint4_linear_6779_1493)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7905 23.6399H22.3574C22.2486 23.6399 22.1443 23.5967 22.0674 23.5198C21.9905 23.4428 21.9473 23.3385 21.9473 23.2297C21.9473 23.121 21.9905 23.0166 22.0674 22.9397C22.1443 22.8628 22.2486 22.8196 22.3574 22.8196H31.7905C31.8993 22.8196 32.0036 22.8628 32.0806 22.9397C32.1575 23.0166 32.2007 23.121 32.2007 23.2297C32.2007 23.3385 32.1575 23.4428 32.0806 23.5198C32.0036 23.5967 31.8993 23.6399 31.7905 23.6399Z",
    fill: "url(#paint5_linear_6779_1493)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7905 27.0579H22.3574C22.2486 27.0579 22.1443 27.0146 22.0674 26.9377C21.9905 26.8608 21.9473 26.7565 21.9473 26.6477C21.9473 26.5389 21.9905 26.4346 22.0674 26.3577C22.1443 26.2808 22.2486 26.2375 22.3574 26.2375H31.7905C31.8993 26.2375 32.0036 26.2808 32.0806 26.3577C32.1575 26.4346 32.2007 26.5389 32.2007 26.6477C32.2007 26.7565 32.1575 26.8608 32.0806 26.9377C32.0036 27.0146 31.8993 27.0579 31.7905 27.0579Z",
    fill: "url(#paint6_linear_6779_1493)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8237 31.5693H32.1748C32.066 31.5693 31.9617 31.5261 31.8848 31.4492C31.8079 31.3723 31.7646 31.268 31.7646 31.1592C31.7646 31.0504 31.8079 30.9461 31.8848 30.8692C31.9617 30.7922 32.066 30.749 32.1748 30.749H34.8237C34.9325 30.749 35.0368 30.7922 35.1138 30.8692C35.1907 30.9461 35.2339 31.0504 35.2339 31.1592C35.2339 31.268 35.1907 31.3723 35.1138 31.4492C35.0368 31.5261 34.9325 31.5693 34.8237 31.5693Z",
    fill: "url(#paint7_linear_6779_1493)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8591 31.5693H39.5078C39.399 31.5693 39.2947 31.5261 39.2178 31.4492C39.1409 31.3723 39.0977 31.268 39.0977 31.1592C39.0977 31.0504 39.1409 30.9461 39.2178 30.8692C39.2947 30.7922 39.399 30.749 39.5078 30.749H44.8591C44.9678 30.749 45.0722 30.7922 45.1491 30.8692C45.226 30.9461 45.2692 31.0504 45.2692 31.1592C45.2692 31.268 45.226 31.3723 45.1491 31.4492C45.0722 31.5261 44.9678 31.5693 44.8591 31.5693Z",
    fill: "url(#paint8_linear_6779_1493)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4752 31.5693H22.3564C22.2477 31.5693 22.1433 31.5261 22.0664 31.4492C21.9895 31.3723 21.9463 31.268 21.9463 31.1592C21.9463 31.0504 21.9895 30.9461 22.0664 30.8692C22.1433 30.7922 22.2477 30.749 22.3564 30.749H27.4752C27.584 30.749 27.6883 30.7922 27.7652 30.8692C27.8421 30.9461 27.8854 31.0504 27.8854 31.1592C27.8854 31.268 27.8421 31.3723 27.7652 31.4492C27.6883 31.5261 27.584 31.5693 27.4752 31.5693Z",
    fill: "url(#paint9_linear_6779_1493)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8593 34.9873H38.7031C38.5943 34.9873 38.49 34.9441 38.4131 34.8672C38.3362 34.7903 38.293 34.6859 38.293 34.5771C38.293 34.4684 38.3362 34.364 38.4131 34.2871C38.49 34.2102 38.5943 34.167 38.7031 34.167H44.8593C44.9681 34.167 45.0725 34.2102 45.1494 34.2871C45.2263 34.364 45.2695 34.4684 45.2695 34.5771C45.2695 34.6859 45.2263 34.7903 45.1494 34.8672C45.0725 34.9441 44.9681 34.9873 44.8593 34.9873Z",
    fill: "url(#paint10_linear_6779_1493)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5013 34.9873H22.3564C22.2477 34.9873 22.1433 34.9441 22.0664 34.8672C21.9895 34.7903 21.9463 34.6859 21.9463 34.5771C21.9463 34.4684 21.9895 34.364 22.0664 34.2871C22.1433 34.2102 22.2477 34.167 22.3564 34.167H28.5013C28.61 34.167 28.7144 34.2102 28.7913 34.2871C28.8682 34.364 28.9114 34.4684 28.9114 34.5771C28.9114 34.6859 28.8682 34.7903 28.7913 34.8672C28.7144 34.9441 28.61 34.9873 28.5013 34.9873Z",
    fill: "url(#paint11_linear_6779_1493)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8592 38.4053H39.1055C38.9967 38.4053 38.8924 38.3621 38.8154 38.2851C38.7385 38.2082 38.6953 38.1039 38.6953 37.9951C38.6953 37.8863 38.7385 37.782 38.8154 37.7051C38.8924 37.6282 38.9967 37.585 39.1055 37.585H44.8592C44.968 37.585 45.0723 37.6282 45.1492 37.7051C45.2261 37.782 45.2694 37.8863 45.2694 37.9951C45.2694 38.1039 45.2261 38.2082 45.1492 38.2851C45.0723 38.3621 44.968 38.4053 44.8592 38.4053Z",
    fill: "url(#paint12_linear_6779_1493)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9879 38.4053H22.3564C22.2477 38.4053 22.1433 38.3621 22.0664 38.2851C21.9895 38.2082 21.9463 38.1039 21.9463 37.9951C21.9463 37.8863 21.9895 37.782 22.0664 37.7051C22.1433 37.6282 22.2477 37.585 22.3564 37.585H27.9879C28.0967 37.585 28.201 37.6282 28.2779 37.7051C28.3548 37.782 28.398 37.8863 28.398 37.9951C28.398 38.1039 28.3548 38.2082 28.2779 38.2851C28.201 38.3621 28.0967 38.4053 27.9879 38.4053Z",
    fill: "url(#paint13_linear_6779_1493)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3378 41.8232H31.6621C31.5533 41.8232 31.449 41.78 31.3721 41.7031C31.2952 41.6262 31.252 41.5219 31.252 41.4131C31.252 41.3043 31.2952 41.2 31.3721 41.1231C31.449 41.0461 31.5533 41.0029 31.6621 41.0029H35.3378C35.4466 41.0029 35.5509 41.0461 35.6278 41.1231C35.7047 41.2 35.7479 41.3043 35.7479 41.4131C35.7479 41.5219 35.7047 41.6262 35.6278 41.7031C35.5509 41.78 35.4466 41.8232 35.3378 41.8232Z",
    fill: "url(#paint14_linear_6779_1493)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8594 41.8232H39.2461C39.1373 41.8232 39.033 41.78 38.9561 41.7031C38.8791 41.6262 38.8359 41.5219 38.8359 41.4131C38.8359 41.3043 38.8791 41.2 38.9561 41.1231C39.033 41.0461 39.1373 41.0029 39.2461 41.0029H44.8594C44.9682 41.0029 45.0725 41.0461 45.1494 41.1231C45.2264 41.2 45.2696 41.3043 45.2696 41.4131C45.2696 41.5219 45.2264 41.6262 45.1494 41.7031C45.0725 41.78 44.9682 41.8232 44.8594 41.8232Z",
    fill: "url(#paint15_linear_6779_1493)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8095 41.8232H22.3564C22.2477 41.8232 22.1433 41.78 22.0664 41.7031C21.9895 41.6262 21.9463 41.5219 21.9463 41.4131C21.9463 41.3043 21.9895 41.2 22.0664 41.1231C22.1433 41.0461 22.2477 41.0029 22.3564 41.0029H27.8095C27.9183 41.0029 28.0226 41.0461 28.0995 41.1231C28.1764 41.2 28.2196 41.3043 28.2196 41.4131C28.2196 41.5219 28.1764 41.6262 28.0995 41.7031C28.0226 41.78 27.9183 41.8232 27.8095 41.8232Z",
    fill: "url(#paint16_linear_6779_1493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6779_1493",
    x1: 43.8386,
    y1: 16.752,
    x2: 43.8386,
    y2: 22.4463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6779_1493",
    x1: 33.5,
    y1: 16.3416,
    x2: 33.5,
    y2: 50.6579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6779_1493",
    x1: 19.9648,
    y1: 21.2368,
    x2: 19.9648,
    y2: 22.6724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6779_1493",
    x1: 43.8386,
    y1: 16.3418,
    x2: 43.8386,
    y2: 22.8564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6779_1493",
    x1: 27.074,
    y1: 46.7454,
    x2: 27.074,
    y2: 47.5657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6779_1493",
    x1: 27.074,
    y1: 22.8196,
    x2: 27.074,
    y2: 23.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6779_1493",
    x1: 27.074,
    y1: 26.2375,
    x2: 27.074,
    y2: 27.0579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6779_1493",
    x1: 33.4993,
    y1: 30.749,
    x2: 33.4993,
    y2: 31.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6779_1493",
    x1: 42.1834,
    y1: 30.749,
    x2: 42.1834,
    y2: 31.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6779_1493",
    x1: 24.9158,
    y1: 30.749,
    x2: 24.9158,
    y2: 31.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6779_1493",
    x1: 41.7812,
    y1: 34.167,
    x2: 41.7812,
    y2: 34.9873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6779_1493",
    x1: 25.4289,
    y1: 34.167,
    x2: 25.4289,
    y2: 34.9873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6779_1493",
    x1: 41.9823,
    y1: 37.585,
    x2: 41.9823,
    y2: 38.4053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6779_1493",
    x1: 25.1722,
    y1: 37.585,
    x2: 25.1722,
    y2: 38.4053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6779_1493",
    x1: 33.5,
    y1: 41.0029,
    x2: 33.5,
    y2: 41.8232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6779_1493",
    x1: 42.0528,
    y1: 41.0029,
    x2: 42.0528,
    y2: 41.8232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6779_1493",
    x1: 25.083,
    y1: 41.0029,
    x2: 25.083,
    y2: 41.8232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestRejectActivityIcon);
export default __webpack_public_path__ + "static/media/InterestReject-Activity-icon.d9c7677acf42e6a7217c4b87f9d4d443.svg";
export { ForwardRef as ReactComponent };